import React from 'react';
import { Box, Typography, Button } from '@mui/material';

// v2.29 - Added startIcon support for actionButton - 2026-01-30
interface TopBarProps {
  title: string;
  subtitle?: string;
  actionButton?: {
    label: string;
    onClick: () => void;
    startIcon?: React.ReactNode;
  };
}

const TopBar: React.FC<TopBarProps> = ({ title, subtitle, actionButton }) => {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        padding: '1.5rem 2rem',
        boxShadow: '0 2px 10px rgba(0, 51, 102, 0.05)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box>
        <Typography variant="h4" sx={{ color: '#003366', fontSize: '1.75rem', fontWeight: 700 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography sx={{ color: '#003366', opacity: 0.7, fontSize: '0.9rem' }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      {actionButton && (
        <Button
          variant="contained"
          onClick={actionButton.onClick}
          startIcon={actionButton.startIcon}
          sx={{
            backgroundColor: '#F4A261',
            color: 'white',
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#e89251',
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.3s',
          }}
        >
          {actionButton.label}
        </Button>
      )}
    </Box>
  );
};

export default TopBar;
